export const DADATA_APIKEY = "c6100f76b1d95c483ec5e70500a31c13246fd62f"
export const PROD_API_PATH = "https://aqua-warranty.ru";
export const DEV_API_PATH = "https://dev-stand.warranty.aquaart.tech";

export enum ENV_TYPE {prod = "prod", dev="dev", local="local"}